import { useLocation } from "react-router";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { useIsReportRoute } from "../../hooks";
const useActiveReportPage = () => {
    const { pathname } = useLocation();
    const { isRoot, isNestedFileBrowser } = useIsReportRoute();
    const lastSegment = pathname.split("/").pop();
    if (isRoot || !lastSegment) {
        return undefined;
    }
    else if (isNestedFileBrowser) {
        return REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE;
    }
    else if (pathname.includes(`/${REPORT_PAGES_ROUTES.VERSION_DIFF}`)) {
        return REPORT_PAGES_ROUTES.VERSION_DIFF;
    }
    else if (pathname.includes(`/${REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE}`)) {
        return REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE;
    }
    else {
        return lastSegment;
    }
};
export default useActiveReportPage;
//# sourceMappingURL=useActiveReportPage.js.map